// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__UpD7D","title":"ClientReferral_title__2vGCh","itemText":"ClientReferral_itemText__2Lpjj"};